import React, { PureComponent } from 'react'
import styles from './styles'

import CallToAction from 'app/Components/CallToAction/Button'

export default class GetInvolved extends PureComponent {
  static propTypes = {
  }

  render() {
    return (
      <div className={styles.wrapper}>
        <div className={styles.row}>
          <div className={styles.col}>
            <h2>
              <div className={styles.grey}>Get Involved With The</div>
              <div className={styles.blue}>SuperAdult Revolution</div>
            </h2>
            <p>
              Whether it's with contributions or a strategic business
              sponsorship, we want to build strong and impacting relationships
              with individuals, companies, and organizations that support the
              Super Adults movement and want to see it progress.
            </p>
          </div>
        </div>
        <div className={styles.buttonDiv} >
          <CallToAction />
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ../app/Components/GetInvolved/GetInvolved.js
 **/